import { apiSlice } from "@app/api/apiSlice";

export const productApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllProducts: builder.query({
      query: (query) => ({
        url: `product?${query}`,
      }),
    }),
    loadOneProductDetail: builder.mutation({
      query: (id) => ({
        url: `product/product/${id}`,
      }),
    }),
    loadProductGroup: builder.mutation({
      query: (id) => ({
        url: `product-type/${id}`,
      }),
    }),
    saveProduct: builder.mutation({
      query: (body) => ({
        url: "product",
        method: "POST",
        body,
      }),
    }),
    deleteSingleProduct: builder.mutation({
      query: (id) => ({
        url: `product/delete/${id}`,
        method: "DELETE",
      }),
    }),
    deleteMultipleProduct: builder.mutation({
      query: (productId) => ({
        url: `product/status/multiple`,
        method: "POST",
        body: { product_id: productId, type: "is_deleted" },
      }),
    }),
    changeMultipleActiveStatus: builder.mutation({
      query: (productId) => ({
        url: `product/status/multiple`,
        method: "POST",
        body: { product_id: productId, type: "is_active" },
      }),
    }),
    changeMultiplePublishedStatus: builder.mutation({
      query: (productId) => ({
        url: `product/status/multiple`,
        method: "POST",
        body: { product_id: productId, type: "is_published" },
      }),
    }),
  }),

  overrideExisting: true,
});

export const {
  useLoadAllProductsQuery,
  useLoadOneProductDetailMutation,
  useLoadProductGroupMutation,
  useSaveProductMutation,
  useDeleteSingleProductMutation,
  useLoadSellerQuery,
  useDeleteMultipleProductMutation,
  useChangeMultipleActiveStatusMutation,
  useChangeMultiplePublishedStatusMutation,
} = productApiSlice;
